import urlBuilder from '@sanity/image-url'
import sanityClient from '../sanity-client'
import {getImageDimensions} from '@sanity/asset-utils'

export default function SanityImage({value, isInline}: any) {
  const {width, height} = getImageDimensions(value)
  return (
    <img
      src={urlBuilder(sanityClient)
        .image(value)
        .fit('max')
        .auto('format')
        .url()}
      alt={value.alt || ' '}
      loading="lazy"
      className="mt-3"
      style={{
        // Display alongside text if image appears inside a block text span
        display: isInline ? 'inline-block' : 'block',

        // Avoid jumping around with aspect-ratio CSS property
        aspectRatio: width / height,
      }}
    />
  )
}